import { registerResetCallback } from './resetRegistry';
let forcedOutcome;
export const setMockForcedOutcome = (outcome) => {
    forcedOutcome = outcome;
};
export const getMockForcedOutcome = () => {
    return forcedOutcome;
};
registerResetCallback(() => {
    forcedOutcome = undefined;
});
